import { CatalogRouting } from '@aipb/gulliver/catalog/routing';
import { DateFnsAdapter, MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Routes } from '@angular/router';
import { cs } from 'date-fns/esm/locale';
import { CatalogInitGuard } from './catalog.init-guard';
import { EntryComponent } from './entry/entry.component';

export const CatalogRoutes: Routes = [
  {
    path: '',
    redirectTo: 'default',
    pathMatch: 'prefix'
  },
  {
    path: CatalogRouting.configPath,
    component: EntryComponent,
    canActivate: [CatalogInitGuard],
    providers: [
      { provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
      { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
      { provide: MAT_DATE_LOCALE, useValue: cs },
      CatalogInitGuard
    ],
    children: [
      {
        path: '',
        redirectTo: CatalogRouting.dashboardPath,
        pathMatch: 'full'
      },
      {
        path: CatalogRouting.dashboardPath,
        loadChildren: () => import('@aipb/gulliver/catalog/feature-dashboard').then((m) => m.DashboardRoutes)
      },
      {
        path: CatalogRouting.searchPath,
        loadChildren: () => import('@aipb/gulliver/catalog/feature-search').then((m) => m.SearchRoutes)
      },
      {
        path: CatalogRouting.detailPath,
        loadChildren: () => import('@aipb/gulliver/catalog/feature-detail').then((m) => m.DetailRoutes)
      },
      {
        path: CatalogRouting.settingsPath,
        loadChildren: () => import('@aipb/gulliver/catalog/feature-settings').then((m) => m.SettingsRoutes)
      },
      {
        path: CatalogRouting.newsPath,
        loadChildren: () => import('@aipb/gulliver/catalog/feature-news').then((m) => m.NewsRoutes)
      },
      {
        path: CatalogRouting.topicPath,
        loadChildren: () => import('@aipb/gulliver/catalog/feature-topic').then((m) => m.TopicRoutes)
      },
      {
        path: CatalogRouting.comparePath,
        loadChildren: () => import('@aipb/gulliver/catalog/feature-compare').then((m) => m.CompareRoutes)
      }
    ]
  }
];
